export default "__VITE_ASSET__6e0a950c__"